/**
 * Waarom een woning geen coördinaat heeft.
 *
 * De scrape mengt twee dingen door elkaar: bestaande koopwoningen met een adres,
 * en nieuwbouwprojecten die nog geen huisnummer hebben ("Aletta Heights (Bouwnr.
 * 0208)", "Reigersbospad CPO kavel"). De eerste groep hoort op de kaart en staat
 * er alleen niet als de geocoder geen treffer vond die op de postcode past; de
 * tweede groep hoort daar terecht niet te staan. Zonder dat onderscheid leest
 * "34 zonder coördinaat" als vierendertig mislukkingen.
 *
 * De reden wordt uit de rij zelf afgeleid - er is geen veld in de bron dat hem
 * bijhoudt - en zegt daarom alleen wat er aan de rij te zien is.
 */

export type ZonderPuntReden = 'geen_postcode' | 'geen_huisnummer' | 'niet_gevonden';

export const ZONDER_PUNT_REDEN_TEKST: Record<ZonderPuntReden, string> = {
  geen_postcode: 'Geen postcode',
  geen_huisnummer: 'Nieuwbouw, nog geen huisnummer',
  niet_gevonden: 'Adres niet gevonden',
};

/**
 * Een huisnummer staat in deze bron achteraan het adres: "Ruyschstraat 357",
 * "Keizersgracht 100 A". Een projectnaam eindigt niet op een nummer, ook niet als
 * er cijfers in zitten: "(Bouwnr. 0208)" eindigt op een haakje.
 */
export function heeftHuisnummer(adres: string): boolean {
  return /\s\d+\s*[a-zA-Z]?$/.test(adres.trim());
}

export function zonderPuntReden(woning: {
  adres: string;
  postcode: string | null;
}): ZonderPuntReden {
  if (!heeftHuisnummer(woning.adres)) return 'geen_huisnummer';
  if (woning.postcode === null || woning.postcode.trim() === '') return 'geen_postcode';
  return 'niet_gevonden';
}

export function heeftPunt(woning: { lat: number | null; lng: number | null }): boolean {
  return woning.lat !== null && woning.lng !== null;
}
